import { ComponentProps, ReactNode } from 'react';
import clsx from 'clsx';

import styles from './BlogPostCard.module.css';

interface BlogPostCardProps extends Omit<ComponentProps<'a'>, 'title'> {
  image: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  footer?: ReactNode;
  href?: string;
  compact?: boolean;
  loading?: boolean;
}

export default function BlogPostCard({
  image,
  title,
  description,
  footer,
  href,
  className,
  compact,
  loading,
  ...props
}: BlogPostCardProps) {
  const Tag = href ? 'a' : 'article';

  if (loading) {
    return (
      <div className={clsx(styles.card, compact && styles.compact, styles.loading, className)}>
        <div className={styles.image}>Loading...</div>

        <div className={styles.content}>
          <h3 className={styles.title}>Loading...</h3>
          <p className={styles.description}>Loading...</p>

          <div className={styles.footer}>Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <Tag
      className={clsx(styles.card, compact && styles.compact, className)}
      href={href}
      {...props}
    >
      <div className={styles.image}>{image}</div>

      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        {description ? <p className={styles.description}>{description}</p> : null}
        <div className={styles.spacer} />

        {footer ? <div className={styles.footer}>{footer}</div> : null}
      </div>
    </Tag>
  );
}
